import { render } from "./FormatQuoteClose.vue?vue&type=template&id=6da8a82f"
import script from "./FormatQuoteClose.vue?vue&type=script&lang=js"
export * from "./FormatQuoteClose.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatQuoteClose.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6da8a82f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6da8a82f', __exports__)) {
    api.reload('6da8a82f', __exports__)
  }
  
  module.hot.accept("./FormatQuoteClose.vue?vue&type=template&id=6da8a82f", () => {
    api.rerender('6da8a82f', render)
  })

}


export default __exports__